/*
 * Third party
 */
//= ../../bower_components/jquery/dist/jquery.js
//= ../../bower_components/tether/dist/js/tether.js
//= ../../bower_components/bootstrap/dist/js/bootstrap.js

window.$ = window.jQuery = require('jquery')

$.ajaxSetup({
  headers: { 'X-CSRF-TOKEN': window.Platform.csrfToken },
});

window.Popper = require('popper.js').default
window.device = require('device.js').device

require('bootstrap/dist/js/bootstrap.min')

/*
 * Custom
 */
require('./partials/app')
